
 export const region=[
      {
        "state": "Andhra Pradesh",
        "capital": "Amaravati",
        "population": 49577103
      },
      {
        "state": "Arunachal Pradesh",
        "capital": "Itanagar",
        "population": 1383727
      },
      {
        "state": "Assam",
        "capital": "Dispur",
        "population": 31205576
      },
      {
        "state": "Bihar",
        "capital": "Patna",
        "population": 104099452
      },
      {
        "state": "Chhattisgarh",
        "capital": "Raipur",
        "population": 25545198
      },
      {
        "state": "Goa",
        "capital": "Panaji",
        "population": 1458545
      },
      {
        "state": "Gujarat",
        "capital": "Gandhinagar",
        "population": 60439692
      },
      {
        "state": "Haryana",
        "capital": "Chandigarh",
        "population": 25351462
      },
      {
        "state": "Himachal Pradesh",
        "capital": "Shimla",
        "population": 6864602
      },
      {
        "state": "Jharkhand",
        "capital": "Ranchi",
        "population": 32988134
      },
      {
        "state": "Karnataka",
        "capital": "Bengaluru",
        "population": 61095297
      },
      {
        "state": "Kerala",
        "capital": "Thiruvananthapuram",
        "population": 33406061
      },
      {
        "state": "Madhya Pradesh",
        "capital": "Bhopal",
        "population": 72626809
      },
      {
        "state": "Maharashtra",
        "capital": "Mumbai",
        "population": 112374333
      },
      {
        "state": "Manipur",
        "capital": "Imphal",
        "population": 2855794
      },
      {
        "state": "Meghalaya",
        "capital": "Shillong",
        "population": 2966889
      },
      {
        "state": "Mizoram",
        "capital": "Aizawl",
        "population": 1097206
      },
      {
        "state": "Nagaland",
        "capital": "Kohima",
        "population": 1978502
      },
      {
        "state": "Odisha",
        "capital": "Bhubaneswar",
        "population": 41974218
      },
      {
        "state": "Punjab",
        "capital": "Chandigarh",
        "population": 27743338
      },
      {
        "state": "Rajasthan",
        "capital": "Jaipur",
        "population": 68548437
      },
      {
        "state": "Sikkim",
        "capital": "Gangtok",
        "population": 610577
      },
      {
        "state": "Tamil Nadu",
        "capital": "Chennai",
        "population": 72147030
      },
      {
        "state": "Telangana",
        "capital": "Hyderabad",
        "population": 35003674
      },
      {
        "state": "Tripura",
        "capital": "Agartala",
        "population": 3673917
      },
      {
        "state": "Uttar Pradesh",
        "capital": "Lucknow",
        "population": 199812341
      },
      {
        "state": "Uttarakhand",
        "capital": "Dehradun",
        "population": 10086292
      },
      {
        "state": "West Bengal",
        "capital": "Kolkata",
        "population": 91276115
      }
    ]
  
  